import { Processo } from "@/models/processo";
import BeneficiarioCearaAppAuthService from "@/services/beneficiarioCearaApp.auth.service";
import { Route } from "vue-router";
import ProcessoService from "@/services/processo.service";
import GlobalStore from "@/store/modules/global";

export const hasInclusionAndFinishedRegisterCearaApp = async (
  to: Route,
  from: Route,
  next: any
) => {
  const { id, processo } = to.params;
  ProcessoService.show(Number(processo)).subscribe(res => {
    const processo = res;

    const hasFinishedRegister = BeneficiarioCearaAppAuthService.hasFinishedRegister(
      processo
    );

    const hasInclusionProcess = BeneficiarioCearaAppAuthService.hasInclusionProcess(
      processo
    );

    if (!hasFinishedRegister && hasInclusionProcess) {
      next();
    } else {
      GlobalStore.setSnackBar({
        type: "warning",
        message: "Esse processo não pode ser alterado.",
        show: true
      });
      next({ name: "ceara-app-passe-livre-detalhe", params: { id } });
    }
  });
};

export const canRegisterCearaApp = async (
  to: Route,
  from: Route,
  next: any
) => {
  const beneficiario = BeneficiarioCearaAppAuthService.currentBeneficiarioValue();

  if (!beneficiario) {
    next();
  } else {
    GlobalStore.setSnackBar({
      type: "warning",
      message: "Você já possue um cadastro.",
      show: true
    });
    next({
      name: "ceara-app-passe-livre-detalhe",
      params: { id: beneficiario.id }
    });
  }
};
